<ng-template #contentHeaderTemplate>
  <div class="row">
    <div class="col-12 d-flex justify-content-end ">
      <button class="btn btn-primary" (click)="save()">
        {{ (publication?.id ? 'misc.save_btn' : 'misc.create_btn') | translate }}
      </button>
    </div>
  </div>
</ng-template>

<div class="row g-3">
  <div class="col-12 col-md-9 order-md-1">
    <form [formGroup]="form" (submit)="save()">
      <div class="card mb-3">
        <div class="card-header">
          {{ 'authenticated.administration.publications.edit.header' | translate }}
        </div>
        <div class="card-body">

          <div class="row">

            <div class="col-12 col-lg-6 py-1">
              <app-form-group
                [formControl]="form.controls.title"
                label="{{'authenticated.administration.publications.edit.form.title.label' | translate }}"
                [errorMessages]="{required: ('authenticated.administration.publications.edit.form.title.validation_messages.required' | translate)}"
              ></app-form-group>
            </div>

            <div class="col-12 col-lg-6 py-1">
              <app-form-group
                [formControl]="form.controls.journal"
                label="{{'authenticated.administration.publications.edit.form.journal.label' | translate }}"
                [errorMessages]="{required: ('authenticated.administration.publications.edit.form.journal.validation_messages.required' | translate)}"
              ></app-form-group>
            </div>

            <div class="col-12 col-lg-6 py-1">
              <app-form-group
                [formControl]="form.controls.link_text"
                label="{{'authenticated.administration.publications.edit.form.link_text.label' | translate }}"
                [errorMessages]="{required: ('authenticated.administration.publications.edit.form.link_text.validation_messages.required' | translate)}"
              ></app-form-group>
            </div>

            <div class="col-12 col-lg-6 py-1">
              <app-form-group
                [formControl]="form.controls.link_destination"
                label="{{'authenticated.administration.publications.edit.form.link_destination.label' | translate }}"
                [errorMessages]="{required: ('authenticated.administration.publications.edit.form.link_destination.validation_messages.required' | translate)}"
              ></app-form-group>
            </div>

            <div class="col-12 col-lg-6 py-1">
              <app-date-time
                [formControl]="form.controls.published_at"
                label="{{'authenticated.administration.publications.edit.form.published_at.label' | translate }}"
                [errorMessages]="{required: ('authenticated.administration.publications.edit.form.published_at.validation_messages.required' | translate)}"
              ></app-date-time>
            </div>

            <div class="col-12 col-lg-6 py-1">
              <app-form-group
                [formControl]="readonlyFormValues.controls.slug"
                label="{{'authenticated.administration.publications.edit.form.slug.label' | translate }}"
              ></app-form-group>
            </div>

            <div class="col-12 col-lg-6 py-1">
              <app-multi-select-with-service-list
                [service]="diagnosisService"
                [filters]="{'is_category': 'false'}"
                [searchOnField]="'title'"
                [formControl]="form.controls.diagnoses"
                label="{{'authenticated.administration.publications.edit.form.diagnosis.label' | translate }}"
                [errorMessages]="{required: ('authenticated.administration.publications.edit.form.diagnosis.validation_messages.required' | translate)}"
                [sort]="'-created_at'"
                [selectionMode]="'multiple_ids'"
              ></app-multi-select-with-service-list>
            </div>

            <div class="col-12 py-1">
              <app-form-group
                [formControl]="form.controls.abstract"
                type="textarea-html"
                label="{{'authenticated.administration.publications.edit.form.abstract.label' | translate }}"
                [errorMessages]="{required: ('authenticated.administration.publications.edit.form.abstract.validation_messages.required' | translate)}"
              ></app-form-group>
            </div>

          </div>

        </div>
      </div>

    </form>

    @if (publication) {
      <div class="card mb-3">
        <div class="card-header">
          {{ 'authenticated.administration.publications.edit.authors.header' | translate }}
        </div>
        <div class="card-body">
          @for (author of publication?.authors ?? []; track author.id) {
            <app-authenticated-administration-publications-authors-show
              [publication]="publication"
              [author]="author"
              (authorDeleted)="reloadAuthors()"
            ></app-authenticated-administration-publications-authors-show>
          }

          @if (!isAddingAuthor) {
            <button (click)="isAddingAuthor = true" class="btn btn-primary mt-1">{{ 'authenticated.administration.publications.edit.authors.create.btn' | translate }}</button>
          } @else {

            <app-authenticated-administration-publications-authors-create
              [publication]="publication"
              (authorCreated)="onAuthorCreated()"
            ></app-authenticated-administration-publications-authors-create>

            <button (click)="isAddingAuthor = false" class="btn btn-danger mt-1">{{ 'authenticated.administration.publications.edit.authors.create.cancel_btn' | translate }}</button>
          }

        </div>
      </div>
    }
  </div>


  <div class="col-12 col-md-3 order-md-2">
    <form [formGroup]="form" (submit)="save()">
      <app-state-card
        formControlName="state"
      ></app-state-card>
    </form>

    @if (publication) {
      <app-delete-card
        [disabled]="publication.state !== ModelStateEnum.DRAFT"
        *appIfHasAllPermissions="[PERMISSION.ADMINISTRATION_PUBLICATION_DELETE_ALL]"
        itemName="{{ 'authenticated.administration.publications.delete.item' | translate }}"
        (deleteTriggered)="deleteItem()"
      ></app-delete-card>
    }
  </div>
</div>
